import { ConverterType } from '../types';
import { AccountConfiguration } from '../hooks/useAccountConfiguration';

export function bankIdToConverter(bankId: string | null | undefined): ConverterType {
  if (!bankId) {
    return '';
  }

  switch (bankId) {
    case 'alrajhi':
      return 'alrajhi';
    case 'wise':
      return 'wise';
    case 'cib':
      return 'cib';
    case 'category':
      return 'category';
    case 'other':
      return 'other';
    default:
      return bankId as ConverterType;
  }
}

export function resolveConverterFromConfig(config: AccountConfiguration): ConverterType {
  return config.activeConverter || bankIdToConverter(config.selectedBank);
}
